// src/screens/customer/customerPannel/faq/FAQ.jsx

import React, { useState, useRef, useEffect, useContext } from "react";
import {
  HelpCircle,
  ChevronDown,
  Search,
  MessageCircle,
  Phone,
} from "lucide-react";
import "../../../../assets/css/customer/customerPannel/faq/FAQ.css";
import axios from "axios";
import AppContext from "../../../../context/AppContext";

const FAQ = () => {
  const [expandedFaq, setExpandedFaq] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("all");
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [faqs, setFaqs] = useState([]);
  const {baseUrl} = useContext(AppContext);
  const dropdownRef = useRef(null);

  const faqData = [
    // {
    //   id: 1,
    //   category: "Orders",
    //   question: "How can I track my order?",
    //   answer:
    //     'Go to "My Orders" and click the order you want to track. You\'ll see real-time updates and estimated delivery date.',
    // },
    // {
    //   id: 2,
    //   category: "Orders",
    //   question: "Can I cancel or modify my order?",
    //   answer:
    //     'You can cancel within 24 hours of placing. Go to "My Orders", select the order, then click "Cancel Order". For modifications contact support.',
    // },
    // {
    //   id: 3,
    //   category: "Payment",
    //   question: "What payment methods do you accept?",
    //   answer:
    //     "Credit/Debit Cards, Cash on Delivery, Bank Transfer, and Mobile Wallets (JazzCash, Easypaisa). All online payments are SSL encrypted.",
    // },
    // {
    //   id: 4,
    //   category: "Delivery",
    //   question: "What is the delivery time?",
    //   answer:
    //     "Standard 5–7 business days. Karachi/Lahore: 3–5 days. Express delivery (2–3 days) available at checkout.",
    // },
    // {
    //   id: 5,
    //   category: "Returns",
    //   question: "What is your return policy?",
    //   answer:
    //     '7-day return policy. Items must be unused in original packaging. Go to "My Returns" to create a request. Refund processed in 5–7 days.',
    // },
    // {
    //   id: 6,
    //   category: "Account",
    //   question: "How do I reset my password?",
    //   answer:
    //     'Click "Settings" → "Change Password". Enter current and new password. Or use "Forgot Password" on the login page.',
    // },
    // {
    //   id: 7,
    //   category: "Products",
    //   question: "Are the furniture items customizable?",
    //   answer:
    //     'Yes! Look for the "Customizable" tag on product pages. Choose fabric, color, and size. Contact support for custom orders.',
    // },
    // {
    //   id: 8,
    //   category: "Warranty",
    //   question: "Do you offer warranty on furniture?",
    //   answer:
    //     "1-year manufacturer warranty covering defects. Extended warranty options available at checkout.",
    // },
    // {
    //   id: 9,
    //   category: "Delivery",
    //   question: "Do you deliver to all cities?",
    //   answer:
    //     "Major cities: Karachi, Lahore, Islamabad, Rawalpindi, Faisalabad, Multan. Contact support for other cities.",
    // },
    // {
    //   id: 10,
    //   category: "Payment",
    //   question: "Is Cash on Delivery available?",
    //   answer:
    //     "Yes, COD available for most locations. Charges may apply depending on order value and delivery location.",
    // },
    // {
    //   id: 11,
    //   category: "Products",
    //   question: "How do I know if a product is in stock?",
    //   answer:
    //     "Availability shown on each product page. Subscribe to restock notifications if out of stock.",
    // },
    // {
    //   id: 12,
    //   category: "Returns",
    //   question: "How long does a refund take?",
    //   answer:
    //     "After receiving and verifying the item, refunds processed in 5–7 business days to your original payment method.",
    // },
  ];

  const categories = ["all", ...new Set(faqs.map((f) => f.category))];

  const viewAllCustomerFaq = () => {
    console.log("Customer view FAQ called!");
    axios.get(`${baseUrl}/customer/faq/viewAllCustomerFaq`)
    .then((response) => {
      console.log(response.data.faqs);
      setFaqs(response.data.faqs);
    }).catch((error) => {
      console.log(error);
    })
  }
  useEffect(() => {
    viewAllCustomerFaq();
  },[])

  const filtered = faqs.filter((f) => {
    const matchCat =
      selectedCategory === "all" || f.category === selectedCategory;
    const matchSearch =
      f.question.toLowerCase().includes(searchQuery.toLowerCase()) ||
      f.answer.toLowerCase().includes(searchQuery.toLowerCase());
    return matchCat && matchSearch;
  });

  // Close dropdown on outside click
  useEffect(() => {
    const handler = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target))
        setDropdownOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const categoryLabel =
    selectedCategory === "all" ? "All Topics" : selectedCategory;

  return (
    <div className="faq-page">
      {/* Header */}
      <div className="faq-header">
        <div className="faq-header-icon">
          <HelpCircle size={22} strokeWidth={1.8} />
        </div>
        <div>
          <h1 className="faq-title">Frequently Asked Questions</h1>
          <p className="faq-subtitle">
            Find answers to common questions about AD Furniture House
          </p>
        </div>
      </div>

      {/* Search + Category Dropdown Row */}
      <div className="faq-controls">
        <div className="faq-search-wrap">
          <Search size={16} strokeWidth={1.8} className="faq-search-icon" />
          <input
            type="text"
            className="faq-search-input"
            placeholder="Search questions..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </div>

        <div className="faq-dropdown-wrap" ref={dropdownRef}>
          <button
            className="faq-dropdown-btn"
            onClick={() => setDropdownOpen(!dropdownOpen)}
          >
            <span>{categoryLabel}</span>
            <ChevronDown
              size={16}
              className={`faq-dropdown-chevron ${dropdownOpen ? "faq-dropdown-chevron-open" : ""}`}
            />
          </button>
          {dropdownOpen && (
            <div className="faq-dropdown-menu">
              {categories.map((c, i) => (
                <button
                  key={i}
                  className={`faq-dropdown-item ${selectedCategory === c ? "faq-dropdown-item-active" : ""}`}
                  onClick={() => {
                    setSelectedCategory(c);
                    setDropdownOpen(false);
                  }}
                >
                  {c === "all" ? "All Topics" : c}
                </button>
              ))}
            </div>
          )}
        </div>
      </div>

      {/* FAQ List */}
      <div className="faq-list">
        {filtered.length > 0 ? (
          filtered.map((f) => (
            <div
              key={f.id}
              className={`faq-item ${expandedFaq === f.id ? "faq-item-open" : ""}`}
            >
              <button
                className="faq-question"
                onClick={() =>
                  setExpandedFaq(expandedFaq === f.id ? null : f.id)
                }
              >
                <div className="faq-question-left">
                  <span className="faq-cat-badge">{f.category}</span>
                  <span className="faq-question-text">{f.question}</span>
                </div>
                <ChevronDown
                  size={18}
                  className={`faq-chevron ${expandedFaq === f.id ? "faq-chevron-open" : ""}`}
                />
              </button>
              {expandedFaq === f.id && (
                <div className="faq-answer">{f.answer}</div>
              )}
            </div>
          ))
        ) : (
          <div className="faq-empty">
            <HelpCircle size={40} strokeWidth={1.5} />
            <h3>No questions found</h3>
            <p>Try different keywords or change the category filter</p>
            <button
              className="faq-reset-btn"
              onClick={() => {
                setSearchQuery("");
                setSelectedCategory("all");
              }}
            >
              Clear Filters
            </button>
          </div>
        )}
      </div>

      {/* Still need help */}
      {/* <div className="faq-help-section">
        <h2 className="faq-help-title">Still have questions?</h2>
        <p className="faq-help-sub">Our support team is here to help</p>
        <div className="faq-help-cards">
          <div className="faq-help-card">
            <div className="faq-help-icon-wrap"><MessageCircle size={20} strokeWidth={1.8} color="#D67E43" /></div>
            <div className="faq-help-info">
              <h3>Live Chat</h3>
              <p>Chat with support team</p>
            </div>
            <button className="faq-help-btn">Start Chat</button>
          </div>
          <div className="faq-help-card">
            <div className="faq-help-icon-wrap"><Phone size={20} strokeWidth={1.8} color="#5C6B47" /></div>
            <div className="faq-help-info">
              <h3>Call Us</h3>
              <p>+92 300 1234567</p>
            </div>
            <button className="faq-help-btn faq-help-btn-green">Call Now</button>
          </div>
        </div>
      </div> */}
    </div>
  );
};

export default FAQ;
